/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pension'
export default icon
